import React from 'react';
import './CalendarCoverageSetting.css';

const help='Receive enabled calendar change notifications even when the event had already ended and the edit keeps it in the past. Notification type and channel settings still apply.';
export default function PastEventChangesSetting({prefs,onChange,disabled=false}) {
  return <label className="notification-calendar-coverage"><input type="checkbox" checked={prefs.includePastEventChanges===true} disabled={disabled} onChange={event=>onChange(event.target.checked)}/><strong>Include changes to past events <span className="notification-calendar-help" tabIndex={0} title={help} aria-label={help}>?</span></strong></label>;
}
